import { combineReducers } from 'redux';
import locale from './Lang/reducer';
import snackbar from './Snackbar/reducer';
import loader from './Loader/reducer';
import navigation from './Navigation/reducer';
import auth from './Auth/reducer';
import admins from './Admins/reducer';
import categories from './Categories/reducer';
import specialties from './Specialties/reducer';
import services from './Services/reducer';
import providers from './Providers/reducer';
import googleMapCoords from './GoogleMapCoords/reducer';
import branches from './Branches/reducer';
import employees from './Employees/reducer';
import customers from './Customers/reducer';
import bookings from './Bookings/reducer'
import lookUps from './LookUps/reducer';
import settings from './Settings/reducer' 
import notifications from './Notifications/reducer';
import paymentTransactions from './PaymentTransactions/reducer';
import outstandingBalance from './OutstandingBalance/reducer';
import expenses from './Expenses/reducer';
import * as types from './Auth/types';

const appReducer = combineReducers({
  locale,
  snackbar,
  loader,
  navigation,
  auth,
  admins,
  categories,
  specialties,
  services,
  providers,
  googleMapCoords,
  branches,
  employees,
  customers,
  bookings,
  lookUps,
  settings,
  notifications,
  paymentTransactions,
  outstandingBalance,
  expenses,
});

const rootReducer = (state, action) => {
  if (action.type === types.LOGOUT_RESPONSE) {
    return appReducer(undefined, action);
  }

  return appReducer(state, action);
};

export default rootReducer;
